






























































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LayoutModal extends Vue {
  @Prop() readonly authorized!: boolean;
  @Prop() readonly layout!: any;

  layout_instance: any = {
    ...this.layout,
  };

  done() {
    this.$emit('done', this.layout_instance);
    this.$emit('close');
  }
}
